import { VOneUrl } from "../url";

/*
The Url endpoints for the License API.

Attributes:
    base: The base url.
    create: The url for creating a License.
    login: The url for logging in a License.
 */
export class UsersUrl extends VOneUrl {
    public base: string;
    public block: string;
    public request_password: string;
    public assign_role: string;
    public unassign_role: string;

    constructor() {
        super();
        this.base = this.defineRoot() + "api/v1/user";
        this.block = this.base + "/block";
        this.request_password = this.base + "/password/reset/request";
        this.assign_role = this.base + "/add/role";
        this.unassign_role = this.base + "/remove/role";
    }
}
